/**
 * 防水墙弹层：遮罩 + srcdoc iframe（captcha.ts 构建），message 回传结果。
 * 点遮罩 = 取消（onDone(undefined)），与 iframe 内关闭验证码同口径。
 */
import { useLayoutEffect, useMemo } from 'preact/hooks';
import styles from './captcha.module.scss';
import { buildCaptchaHtml, newCaptchaToken, readCaptchaMessage, type CaptchaResult } from './captcha';

export function CaptchaDialog(props: {
  appId: string;
  onDone: (result: CaptchaResult | undefined) => void;
}) {
  const { appId, onDone } = props;
  const token = useMemo(newCaptchaToken, []);
  const html = useMemo(() => buildCaptchaHtml(appId, token), [appId, token]);

  // useLayoutEffect（非 useEffect）：commit 同一任务内同步挂 message 监听。
  // useEffect 走 rAF 调度，后台/降频标签页可能晚于 iframe 内脚本的 postMessage
  // 导致结果丢失、弹层卡死（e2e 并发跑实际复现过）。
  useLayoutEffect(() => {
    const handler = (event: MessageEvent) => {
      const msg = readCaptchaMessage(event.data, token);
      if (msg === undefined) return;
      onDone(msg.kind === 'success' ? msg.result : undefined);
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [token, onDone]);

  return (
    <div
      className={styles.overlay}
      data-testid="captcha-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onDone(undefined);
      }}
    >
      <iframe className={styles.frame} title="人机验证" srcDoc={html} />
    </div>
  );
}
